// extracted by mini-css-extract-plugin
export default {"show-more-button":"_4U4j0","showMoreButton":"_4U4j0","show-more-button-large":"MkrSu","showMoreButtonLarge":"MkrSu"};